export function Cross() {
  return (
    <>
      <path d="M11 11L29 29" stroke="currentColor" className="dynamic-stroke-width" />
      <path d="M29 11L11 29" stroke="currentColor" className="dynamic-stroke-width" />
    </>
  )
}
